import React, { useMemo, useRef, useState , useEffect } from 'react';
import { useReactToPrint } from 'react-to-print';
import { find, get } from 'lodash';
import { useAllBook } from 'store/books/selectors';
import { useResources } from 'store/resources/selectors';
import { getNumberMask, isEbook, isVideo } from 'utils/lib/ebookHelper';
import { IconButton } from '@mui/material';
import { Mic, VideocamSharp} from '@mui/icons-material';
import Loading from './Loading';
import './print.css';
import { useDeviceDetection ,useIsTab } from 'containers/chat/hooks';
import PrintPageFillInBlanks from 'features/forms/assignment/fillInBlanks/printPage/printPage';
import { MatchMakingPreview } from 'features/forms/assignment';
import { graphic_data } from 'utils/constants/graphic_org';
import PrintPhotoCollage from 'modules/activityModule/photoCollage/printPhotoCollage';
import { useLocation, useNavigate } from "react-router-dom";
import styled from 'styled-components';
import { useAlert } from './UI/alertSakeBar/alertProvider';
import { Tooltip } from 'antd';
import printSvg from "../utils/assets/images/print.svg";
import SentryWrap from 'components/Sentry';
import { useMobileDetect } from 'hooks/useMobileDetect';
import usePdfFromRef from 'components/hooks/usePdfFromRef';

const PrintSectionWrapper = styled.div`
`;

const getBookDisplayName = (chapter, booksAllList, resources) => {
  let chapterName;
  if (isEbook(chapter, booksAllList)) {
    chapterName = get(find(booksAllList, ["id", chapter]), "description", "");
  } else {
    if (isVideo(chapter, resources)) {
      chapterName = "1Way Resources";
    }
  }
  return chapterName;
}

const handleAddedLabel = (value) => {
  if (typeof value === 'string') {
    return value.replace(/^[a-f][).]\s*/, '');
  }
  return value;
}
const handleremovequs = (value) => {
  if (typeof value === 'string') {
    return value.replace(/^\d+\.\s*/, '');
  }
  return value;
}

const PrintContent = React.forwardRef(({ headerText, footerText, questions, graphicImage, data, isGeneratedTest=false, isUnitExam=false, isExam=false }, ref) => {
  const activityHeadingLabel = isUnitExam
    ? 'EXAMEN DE UNIDAD'
    : isExam
      ? 'PRUEBA'
      : isGeneratedTest
        ? 'ACTIVIDAD GENERADA'
        : 'ACTIVIDAD';
  const divice = useDeviceDetection()
  return (
    divice.isSafari ? (
      <div ref={ref} className="print-container printable" style={{ position: "relative" }}>
        <div className="watermark">
          <p style={{ marginRight: '10px' }}>One Way Education</p>
        </div>
        <table className="report-container" border="0" style={{ width: '100%', borderCollapse: 'collapse', position: "relative", border: 'none' }}>
          <thead>
            <tr>
              <th colSpan={2} style={{ backgroundColor: "#2d8bba", color: '#fff', textAlign: 'left', border: 'none' }}>
                <div style={{ padding: '0px 0px 0 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div>
                    <p style={{ margin: 0, fontSize: '20px', lineHeight: '30px' }}>One Way Education</p>
                    <p style={{ margin: 0, fontSize: '20px' }}>{headerText}</p>
                  </div>
                  <img src="https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fbird.png?alt=media&token=6a9a7f5a-4959-431c-a305-8eabe60a4d46" alt="Bird" style={{ height: '100px', width: 'auto' }} />
                </div>
              </th>
            </tr>
          </thead>
          
          <tbody className="report-content">
            <tr>
              <td className="report-content-cell" colSpan={2} style={{ border: 'none' }}>
                <div className="main">
                  {data?.activity_type === 'graphic_organizer' ? (
                    graphicImage && <img src={graphicImage} alt="Graphic Organizer" style={{ height: '100%', width: '100%' }} />
                  ) : (
                    <>
                      <div style={{ color: '#800059' }}>
                        <p style={{ fontWeight: 'bolder', fontSize: '25px' }}>{activityHeadingLabel}</p>
                      </div>
                      { Array.isArray(questions) && questions.map((qus, index) => {
                        const options = qus.options || [];
                        return (
                          <div key={index} className="print-question-block" style={{ marginBottom: '10px' }}>
                            <h3 style={{ color: '#1a1a1a', marginBottom: '5px', fontWeight: 'bold', fontSize: 20 }}>
                            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                              <span style={{ marginRight: '10px', flexShrink: 0, lineHeight: 1.4 }}>{`${index + 1}.`}</span>
                              <span style={{ flex: 1 }} className="print-question-text" dangerouslySetInnerHTML={{ __html: handleremovequs(qus.question) || '' }} />
                              </div>
                              {(qus.type === 'audio' || qus.type === 'twoMinAudio' || qus.type === 'audioEssay' || qus.type == 'audioTrueFalse' || qus.fillingType === "Audio" || qus.type == 'audioMultipleChoice' || qus.type === 'audioToImage') && <Mic />}
                              {qus.type === 'video' && <VideocamSharp />}
                            </h3>
                            {qus.type === 'match' && (
                              <MatchMakingPreview question={qus} />
                            )}
                            {(qus.type === 'filling' || qus.type === 'fillingImage') && (
                              <div>
                                <PrintPageFillInBlanks question={qus} options={options} />
                              </div>
                            )}
                            {qus.type === 'photoCollage' && (
                              <PrintSectionWrapper>
                                <PrintPhotoCollage collageFrame={qus?.collageFrame} />
                                {qus?.type_question_desc && <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10, }}>
                                  <span style={{ color: "gray", fontSize: 16, width: "100%" }} dangerouslySetInnerHTML={{ __html: qus?.type_question_desc || '' }} />{qus.categoryType?.includes("Audio") && <Mic />}
                                </div>}
                                {/* Conditionally render answer lines if Text is enabled */}
                                {qus.categoryType?.includes("Text") && (
                                  <div style={{ lineHeight: '1.6', color: '#333', marginTop: '10px', padding: '10px 0' }}>
                                    {Array(10).fill(null).map((_, i) => (
                                      <div
                                        key={i}
                                        style={{
                                          borderBottom: '2px solid black',
                                          height: '35px',
                                          marginBottom: '4px'
                                        }}
                                      />
                                    ))}
                                  </div>
                                )}
                              </PrintSectionWrapper>
                            )}
                            {qus.type === 'multipleChoice' || qus.type === 'trueFalse' || qus.type === 'audioTrueFalse' || qus.type == 'audioMultipleChoice' || qus.type === 'multipleResponse' ? (
                              <ul style={{ lineHeight: 1.6, color: '#333', marginTop: '5px', marginLeft: 20, listStyleType: 'none' }}>
                                {options.map((option, i) => (
                                  <li key={i} style={{ color: '#4a4a4a', fontSize: 16 }}>
                                    {`${String.fromCharCode(97 + i)}) ${handleAddedLabel(option)}`}
                                  </li>
                                ))}
                              </ul>
                            ) : qus.type === 'essay' || qus.type === 'email' || qus.type === 'audioEssay' ? (
                              <div style={{ lineHeight: '1.6', color: '#333', marginTop: '5px' }}>
                                {Array(10).fill(null).map((_, i) => (
                                  <div key={i} style={{ listStyleType: 'none', borderBottom: '2px solid black', height: '35px', paddingTop:'45px' }}></div>
                                ))}
                              </div>
                            ) : qus.type === 'picture' && (
                              <>
                                {(() => {
                                  const allImages = [];
                                  if (qus.pictures) {
                                    if (Array.isArray(qus.pictures)) {
                                      allImages.push(...qus.pictures);
                                    } else {
                                      allImages.push(qus.pictures);
                                    }
                                  }
                                  if (qus.additionalPictures && Array.isArray(qus.additionalPictures)) {
                                    allImages.push(...qus.additionalPictures.filter(img => img));
                                  }
                                  
                                  return allImages.length > 0 ? (
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '10px' }}>
                                      {allImages.map((imageUrl, imgIndex) => (
                                        <img key={imgIndex} src={imageUrl} alt={`Question ${imgIndex + 1}`} style={{ height: '200px', width: '170px', objectFit: 'contain' }} />
                                      ))}
                                    </div>
                                  ) : null;
                                })()}
                                {(qus.categoryType === 'Text' || qus.categoryType === 'ImageAndText' || qus.categoryType === 'Image') && (
                                  <>
                                    {(qus.categoryType === 'ImageAndText' || qus.categoryType === 'Image') && (
                                      <div style={{ marginTop: '15px', border: '2px dashed #ccc', width: '150px', height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <span style={{ color: '#999' }}>Insert Picture Here</span>
                                      </div>
                                    )}
                                    {qus.categoryType !== 'Image' && (
                                      <div style={{ lineHeight: '1.6', color: '#333', marginTop: '5px' }}>
                                        {Array(10).fill(null).map((_, i) => (
                                          <div key={i} style={{ listStyleType: 'none', borderBottom: '2px solid black', height: '35px', paddingTop:'45px' }}></div>
                                        ))}
                                      </div>
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        );
                      })}
                    </>
                  )}
                </div>
              </td>
            </tr>
          </tbody>
          <div className="print-footer-block" style={{ position:'relative', paddingTop: '20px' }}>
              <div style={{ padding: '10px 90px', color: '#fff', textAlign: 'center',  backgroundColor: '#2d8bba' }}>
                <p style={{ margin: 0 }}>{footerText}</p>
              </div>
          </div>
        </table>
        
      </div>
    ) : divice.isIOS && divice.isAndroid ?
      (
        <div ref={ref} className="print-container printable" style={{ position: "relative" }}>
          <div className="watermark">
            <p style={{ marginRight: '10px' }}>One Way Education</p>
          </div>
          <table className="report-container" border="0" style={{ width: '100%', borderCollapse: 'collapse', border: 'none' }}>
            <thead>
              <tr>
                <th colSpan={2} style={{ padding: '10px 90px', backgroundColor: "#2d8bba", color: '#fff', textAlign: 'left', border: 'none' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>
                      <p style={{ margin: 0, fontSize: '20px', lineHeight: '30px' }}>One Way Education</p>
                      <p style={{ margin: 0, fontSize: '20px' }}>{headerText}</p>
                    </div>
                    <img src="https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fbird.png?alt=media&token=6a9a7f5a-4959-431c-a305-8eabe60a4d46" alt="Bird" style={{ height: '100px', width: 'auto' }} />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="report-content">
              <tr>
                <td className="report-content-cell" colSpan={2} style={{ border: 'none' }}>
                  <div className="main">
                    {data?.activity_type === 'graphic_organizer' ? (
                      graphicImage && <img src={graphicImage} alt="Graphic Organizer" style={{ height: '100%', width: '100%' }} />
                    ) : (
                      <>
                        <div style={{ color: '#800059' }}>
                          <p style={{ fontWeight: 'bolder', fontSize: '25px' }}>{activityHeadingLabel}</p>
                        </div>
                        { Array.isArray(questions) && questions.map((qus, index) => {
                          const options = qus.options || [];
                          return (
                            <div key={index} className="print-question-block" style={{ marginBottom: '10px' }}>
                              <h3 style={{ color: '#1a1a1a', marginBottom: '5px', fontWeight: 'bold', fontSize: 20 }}>
                                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                  <span style={{ marginRight: '10px', flexShrink: 0, lineHeight: 1.4 }}>{`${index + 1}.`}</span>
                                  <span style={{ flex: 1 }} className="print-question-text" dangerouslySetInnerHTML={{ __html: qus.question || '' }} />
                                  </div>
                                {(qus.type === 'audio' || qus.type === 'twoMinAudio' || qus.type === 'audioEssay' || qus.type == 'audioTrueFalse' || qus.fillingType === "Audio") && <Mic />}
                                {qus.type === 'video' && <VideocamSharp />}
                              </h3>
                              {qus.type === 'match' && (
                                <MatchMakingPreview question={qus} />
                              )}
                              {(qus.type === 'filling' || qus.type === 'fillingImage') && (
                                <div>
                                  <PrintPageFillInBlanks question={qus} options={options} />
                                </div>
                              )}
                              {qus.type === 'photoCollage' && (
                                <PrintSectionWrapper>
                                  <PrintPhotoCollage collageFrame={qus?.collageFrame} />
                                  {qus?.type_question_desc && <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10, }}>
                                    <span style={{ color: "gray", fontSize: 16, width: "100%" }}>{qus?.type_question_desc} </span>{qus.categoryType?.includes("Audio") && <Mic />}
                                  </div>}
                                  
                                  {/* Conditionally render answer lines if Text is enabled */}
                                  {qus.categoryType?.includes("Text") && (
                                    <div style={{ lineHeight: '1.6', color: '#333', marginTop: '10px', padding: '10px 0' }}>
                                      {Array(10).fill(null).map((_, i) => (
                                        <div
                                          key={i}
                                          style={{
                                            borderBottom: '2px solid black',
                                            height: '35px',
                                            marginBottom: '4px'
                                          }}
                                        />
                                      ))}
                                    </div>
                                  )}
                                </PrintSectionWrapper>
                              )}
                              {qus.type === 'multipleChoice' || qus.type === 'trueFalse' || qus.type == 'audioTrueFalse' || qus.type == 'audioMultipleChoice' || qus.type == 'qus' || qus.type == 'multipleResponse'? (
                                <ul style={{ lineHeight: 1.6, color: '#333', marginTop: '5px', marginLeft: 20, listStyleType: 'none' }}>
                                  {options.map((option, i) => (
                                    <li key={i} style={{ color: '#4a4a4a', fontSize: 16 }}>
                                      {`${String.fromCharCode(97 + i)}) ${option}`}
                                    </li>
                                  ))}
                                </ul>
                              ) : qus.type === 'essay' || qus.type === 'email' || qus.type === 'audioEssay' ? (
                                <div style={{ lineHeight: '1.6', color: '#333', marginTop: '5px' }}>
                                  {Array(10).fill(null).map((_, i) => (
                                    <div key={i} style={{ listStyleType: 'none', borderBottom: '2px solid black', height: '35px', paddingTop:'45px' }}></div>
                                  ))}
                                </div>
                              ) : qus.type === 'audioToImage' ? (
                                <div style={{ marginTop: '15px', border: '2px dashed #ccc', width: '150px', height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  <span style={{ color: '#999' }}>Insert Picture Here</span>
                                </div>
                              ) : qus.type === 'picture' && (
                                <>
                                  {(() => {
                                    const allImages = [];
                                    if (qus.pictures) {
                                      if (Array.isArray(qus.pictures)) {
                                        allImages.push(...qus.pictures);
                                      } else {
                                        allImages.push(qus.pictures);
                                      }
                                    }
                                    if (qus.additionalPictures && Array.isArray(qus.additionalPictures)) {
                                      allImages.push(...qus.additionalPictures.filter(img => img));
                                    }
                                    
                                    return allImages.length > 0 ? (
                                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '10px' }}>
                                        {allImages.map((imageUrl, imgIndex) => (
                                          <img key={imgIndex} src={imageUrl} alt={`Question ${imgIndex + 1}`} style={{ height: '200px', width: '170px', objectFit: 'contain' }} />
                                        ))}
                                      </div>
                                    ) : null;
                                  })()}
                                  {(qus.categoryType === 'Text' || qus.categoryType === 'ImageAndText' || qus.categoryType === 'Image') && (
                                    <>
                                      {(qus.categoryType === 'ImageAndText' || qus.categoryType === 'Image') && (
                                        <div style={{ marginTop: '15px', border: '2px dashed #ccc', width: '150px', height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                          <span style={{ color: '#999' }}>Insert Picture Here</span>
                                        </div>
                                      )}
                                      {qus.categoryType !== 'Image' && (
                                        <div style={{ lineHeight: '1.6', color: '#333', marginTop: '5px' }}>
                                          {Array(10).fill(null).map((_, i) => (
                                            <div key={i} style={{ listStyleType: 'none', borderBottom: '2px solid black', height: '35px', paddingTop:'45px' }}></div>
                                          ))}
                                        </div>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </div>
                          );
                        })}
                      </>
                    )}
                  </div>
                </td>
              </tr>
            </tbody>

            <tfoot className="report-footer report-footerCstm">
              <tr style={{ border: 'none' }}><td colSpan={2} style={{ height: '120px', border: 'none' }}></td></tr>
              <tr style={{ position: 'absolute', border: 'none' }}>
                <td className="report-footer-cell" colSpan={2} style={{ border: 'none' }}>
                  <div className="page-footer-2 print-footer-block" style={{ padding: '10px 90px', color: '#fff', textAlign: 'center' }}>
                    <p style={{ margin: 0 }}>{footerText}</p>
                  </div>
                </td>
              </tr>
            </tfoot>

          </table>
        </div>
      )
      : (
        <div ref={ref} className="print-container printable 3636">
          <div className="graphicOrganizerWaterMark">One Way Education</div>
           <table className="report-containerCstm" border="0" style={{ border: 'none', borderCollapse: 'collapse' }}>

            <div className="header-info">
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0px 20px 0 40px', minHeight: '100px'}}>
                <div style={{position: 'relative', display: 'flex', alignItems: 'center', gap:'0'}}>
                  <div style={{position: 'absolute', left: -80, top: -30}}>
                  <img src="https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fbird.png?alt=media&token=6a9a7f5a-4959-431c-a305-8eabe60a4d46" alt="Bird" style={{ height: '100px', width: 'auto' }} />
                  </div>
                  <p style={{ margin: 0, fontSize: '20px', lineHeight: '30px', color: '#fff' }}>One Way Education</p>
                </div>

                <p style={{ margin: 0, fontSize: '20px', color: '#fff' }}>{headerText}</p>
                
              </div>
            </div>
            
            <tbody className="report-content">
              <tr>
                <td className="report-content-cell" style={{ border: 'none' }}>
                  <div className="main">
                    {data?.activity_type === 'graphic_organizer' ? (
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}>
                        {graphicImage && <img src={graphicImage} style={{ height: '80%', width: '80%' }} alt="Bird" className="" />}
                      </div>
                    ) : (
                      <>
                        <div style={{ color: '#800059' }}>
                          <p style={{ fontWeight: 'bolder', fontSize: '25px' }}>{activityHeadingLabel}</p>
                        </div>
                        { Array.isArray(questions) && questions.map((qus, index) => {
                          const options = qus.options || [];
                          return (
                            <div key={index} className="question-block-print-inline print-question-block">
                              <h3 style={{ color: '#1a1a1a', marginBottom: '0px', fontWeight: 'bold', fontSize: 18, display: 'flex', alignItems: 'flex-start' }} className='multipleChoiceSpcPrintType'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                    <p style={{ marginRight: '10px', marginBottom: '0px' }}>{`${index + 1}.`}</p>
                                    <div style={{ flex: 1 }}>
                                      <p style={{ flex: 1, marginBottom: '0px' }} dangerouslySetInnerHTML={{ __html: qus.question || '' }} />
                                    </div>
                                  </div>
                                </div>
                                {(qus.type === 'audio' || qus.type === 'twoMinAudio' || qus.type === 'audioEssay' || qus.type == 'audioTrueFalse' || qus.fillingType === "Audio" || qus.type == 'audioMultipleChoice' || qus.type === 'audioToImage') && <Mic />}
                                {qus.type === 'video' && <VideocamSharp />}
                                </div>
                              </h3>
                              {qus.type === 'match' && (
                                <MatchMakingPreview question={qus} />
                              )}
                              {qus.type === 'filling' && (
                                <div>
                                  <PrintPageFillInBlanks question={qus} options={options} />
                                </div>
                              )}

                              {qus.type === 'photoCollage' && (
                                <PrintSectionWrapper>
                                  <PrintPhotoCollage collageFrame={qus?.collageFrame} />
                                  {qus?.type_question_desc && <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10, }}>
                                    <span style={{ color: "gray", fontSize: 16, width: "100%" }} dangerouslySetInnerHTML={{ __html: qus?.type_question_desc || '' }} /> {qus.categoryType?.includes("Audio") && <Mic />}
                                  </div>}
                                  <div className='addPrintPaddingSpc'></div>
                                  {/* Conditionally render answer lines if Text is enabled */}
                                  {qus.categoryType?.includes("Text") && (
                                    <div style={{ lineHeight: '1.6', color: '#333', marginTop: '10px', padding: '10px 0' }}>
                                      {Array(10).fill(null).map((_, i) => (
                                        <div
                                          key={i}
                                          style={{
                                            borderBottom: '2px solid black',
                                            height: '35px',
                                            marginBottom: '4px'
                                          }}
                                        />
                                      ))}
                                    </div>
                                  )}
                                  <div className='addPrintPaddingSpc'></div>
                                </PrintSectionWrapper>
                              )}
                              {(qus.type === 'multipleChoice' || qus.type === 'trueFalse' || qus.type == 'audioTrueFalse' || qus.type == 'audioMultipleChoice' || qus.type === 'multipleResponse') && (
                                <ul style={{ lineHeight: 1.4, color: '#333', marginTop: '5px', marginLeft: 20, listStyleType: 'none' }}>
                                  {options.map((option, i) => (
                                    <li key={i} className='multipleChoiceSpcPrintLi' style={{ color: '#4a4a4a', fontSize: 16 }}>
                                      {`${String.fromCharCode(97 + i)}) ${option}`}
                                    </li>
                                  ))}
                                </ul>
                              )}

                              {/* blank line code */}
                              {(qus.type === 'essay' || qus.type === 'email' || qus.type === 'audioEssay') && (
                                <>
                                  <div style={{ lineHeight: '1.4', color: '#333', marginTop: '5px', marginBottom: '0px' }}>
                                    {Array(10).fill(null).map((_, i) => (
                                      <div key={i} style={{ listStyleType: 'none', borderBottom: '2px solid black', height: '35px', paddingTop:'25px' }}></div>
                                    ))}
                                  </div>
                                </>
                              )}
                              {qus.type === 'audioToImage' && (
                                <div style={{ marginTop: '15px', border: '2px dashed #ccc', width: '150px', height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  <span style={{ color: '#999' }}>Insert Picture Here</span>
                                </div>
                              )}
                              {qus.type === 'picture' && (
                                <>
                                  {(() => {
                                    const allImages = [];
                                    if (qus?.pictures) {
                                      if (Array.isArray(qus.pictures)) {
                                        allImages.push(...qus.pictures);
                                      } else {
                                        allImages.push(qus.pictures);
                                      }
                                    }
                                    if (qus?.additionalPictures && Array.isArray(qus.additionalPictures)) {
                                      allImages.push(...qus.additionalPictures.filter(img => img));
                                    }
                                    
                                    return allImages.length > 0 ? (
                                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '10px' }}>
                                        {allImages.map((imageUrl, imgIndex) => (
                                          <img key={imgIndex} src={imageUrl} alt={`Question ${imgIndex + 1}`} style={{ height: '200px', width: '170px', objectFit: 'contain' }} />
                                        ))}
                                      </div>
                                    ) : null;
                                  })()}
                                  {(qus?.categoryType === 'Text' || qus?.categoryType === 'ImageAndText' || qus?.categoryType === 'Image') && (
                                    <>
                                      {(qus?.categoryType === 'ImageAndText' || qus?.categoryType === 'Image') && (
                                        <div style={{ marginTop: '15px', border: '2px dashed #ccc', width: '150px', height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                          <span style={{ color: '#999' }}>Insert Picture Here</span>
                                        </div>
                                      )}
                                      {qus?.categoryType !== 'Image' && (
                                        <div style={{ lineHeight: '1', color: '#333', marginTop: '5px', marginBottom: '10px' }}>
                                          {
                                          Array(10).fill(null).map((_, i) => (
                                            <div key={i} style={{ listStyleType: 'none', borderBottom: '2px solid black', height: '35px', paddingTop:'25px' }}></div>
                                          ))}
                                        </div>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </div>
                          )
                        })}
                      </>
                    )}
                  </div>
                </td>
              </tr>
            </tbody>
            
            <tfoot className="report-footer report-footerCstm">
              <tr style={{ border: 'none' }}><td style={{ height: "120px", border: 'none' }}></td></tr>
              <tr style={{ position: "absolute", left: 0, right: 0, width: "100%", bottom: 0, border: 'none' }}>
                <td className="report-footer-cell" style={{ border: 'none' }}>
                  <div className="footer-info print-footer-block">
                    <div className={"page-footer-3"}>
                      <p style={{ padding: '10px 90px', margin: 0, color: '#fff' }}>
                        {footerText}
                      </p>
                    </div>
                  </div>
                </td>
              </tr>
            </tfoot>

          </table>
        </div>
      )
  );
});
const PrintPage = ({ data, isGeneratedTest, isUnitExam, isExam }) => {
  const showAlert = useAlert();
  const componentRef = useRef();
  const booksAllList = useAllBook();
  const resources = useResources();
  const [printloader, setPrintloader] = useState(false);
  const pageId = get(data, "page");
  const chapter = get(data, "chapter");
  const questions = get(data, "questions");
  const location = useLocation();
  const navigate = useNavigate();
  const [toast, setToast] = useState({
    value: false,
    message: ""
  });
  const isTablate = useIsTab();
  const isMobile = useMobileDetect();
  const { openPdfInNewTabFromRef } = usePdfFromRef();

  const graphicImage = useMemo(() => {
    if (data?.activity_type === "graphic_organizer" || data?.data?.activity_type === "graphic_organizer") {
      let _page = data.assignment_page ? data.assignment_page : data?.data?.assignment_page;
       return graphic_data.find(k=>k.pageId == _page)?.src
    } else {
      return null;
    }

  }, [data])

  let numberMasked;
  numberMasked = getNumberMask(chapter, pageId, booksAllList);
  if (isVideo(chapter, resources)) {
    numberMasked = null;
  }
  const chapterName = getBookDisplayName(chapter, booksAllList, resources)

  function isChromeOniOS() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const isChrome = /CriOS/.test(userAgent);
    return isIOS && isChrome;
  }

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: 'Custom Print Document',
    onBeforeGetContent: async () => { setPrintloader(true) },
    onAfterPrint: async () => {
      setPrintloader(false);
    },
    onPrintError: async () => {
      setPrintloader(false);
    },
  });

  const getHeaderName = () => {
    let havePage = false;
    if (isEbook(chapter, booksAllList)) {
      havePage = true;
    }
    return `${chapterName} ${havePage ? `— Page: ${numberMasked}` : ''}`;
  }

  const redirectToNextPage = () => {
    navigate({
      pathname: '/print_assignment',
      state: data,
    });
  }


  const openPdfInNewTab = async () => {
    await openPdfInNewTabFromRef({
      componentRef,
      onLoadingChange: setPrintloader,
      onError: (message) => showAlert(message, 'error'),
      fileName: `${data?.displayName || 'document'}.pdf`
    });
  };

  const onPrint = () => {
    setPrintloader(true);
    if (isMobile || isTablate) {
      openPdfInNewTab();
      return;
    }
    if (isChromeOniOS()) {
      setPrintloader(false);
      redirectToNextPage();
    } else {
      handlePrint();
    }
  }

  return (
    <SentryWrap>
    <div>
      <IconButton
        style={{ padding: 0, color: "white" }}
        aria-label="print"
        onClick={onPrint}
      >
        {printloader ? <Loading size={20} /> : 
            <img src={printSvg} alt="" title="" /> 
        }
      </IconButton>
      
      <div style={{ display: 'none' }}>
        <PrintContent
          ref={componentRef}
          headerText={getHeaderName()}
          footerText="©One Way Education All rights reserved. Reproduction of this work, whether total or partial, by any means or procedure, including reprography and computer processing, photocopying, or recording, is prohibited without the prior written authorization of the rights holder."
          questions={questions}
          data={data}
          graphicImage={graphicImage}
          isGeneratedTest={isGeneratedTest}
          isUnitExam={isUnitExam}
          isExam={isExam}
        />
      </div>
    </div>
    </SentryWrap>
  );
};

export default PrintPage;
